import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Params, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { ProductService } from 'src/app/features/products/product.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatTabGroup } from '@angular/material/tabs';
import { CurrencyPipe, formatDate } from '@angular/common'; 
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';

@Component({
  selector: 'app-all-products',
  templateUrl: './all-products.component.html',
  styleUrls: ['./all-products.component.scss'],
  providers: [CurrencyPipe]
})
export class AllProductsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  data;
  columnDefs
  columnhistoryDefs
  rowData: any = [];
  rowSelection: string;
  selected: any = 'one month';
  rowhistoryData: any = [];
  rowhistorySelection: string;
  private gridhistoryApi;
  private gridhistoryColumnApi;
  private gridApi;
  private gridColumnApi;
  searchValue;
  searchhistoryValue;
  showEditProduct: boolean = false;
  selectedRows: any;
  showEditRetailer: boolean = false;
  showDeleteRetailer: boolean = false;
  toInactive: any = [];

  isButtonDisabled:boolean

  constructor(private router: Router, private ProductService: ProductService, private currencyPipe: CurrencyPipe,private adminViewServices:AdminViewService) {
    super();
    this.initGrid();
  }

  ngOnInit(): void {
    super.ngOnInit()
       this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }
  ngOnDestroy() {
    super.ngOnDestroy()
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue); 
  }

  editProduct() {
    let _productId = this.selectedRows[0].productId;
    this.router.navigate([`/features/products/edit-product/${_productId}`])
  }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.showEditProduct = true;
      return
    }
    this.showEditProduct = false;
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onInactive() {
    this.selectedRows.forEach(element => {
      this.toInactive.push(element.providerId)
    });
    this.ProductService.productInactive(this.toInactive).subscribe(res => {
      let resData: any = res;
      if (resData && resData.data == "successfull") {
        Swal.fire(
          {
            title: 'Success',
            text: 'Product inactivated successfully',
            icon: 'success',
            timer: 2000
          }
        )
        this.initGrid();
      }
    });
  }


  initGrid() {
    this.ProductService.getproducts().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.setGrid(resData);
      }
    })
  }

  //  products grid initialization
  setGrid(data: any) {
    this.rowData = data; 
    this.rowSelection = 'single';
    this.columnDefs = [
      { field: 'providerId', headerName: 'providerId', width: 0, hide: true },
      { field: 'productId', headerName: 'productId', width: 0, hide: true, sort: "desc" },
      { field: 'null', headerName: 'Action', width: 130, checkboxSelection: true },
      { field: 'sku', headerName: 'SKU ', width: 130 },
      { field: 'productName', headerName: 'Product Name', width: 180 },
      { field: 'productStatus', headerName: 'Status', width: 120 },
      { field: 'productDescription', headerName: 'Product Description', width: 260 },
      { field: 'productDropdownName', headerName: 'Product Dropdown Name', width: 270 },
      { field: 'carrier', headerName: 'Carrier', width: 130 },
      { field: 'widelyUsed', headerName: 'Widely Used', width: 200 },
      { field: 'codeGroup', headerName: 'Code Group', width: 180 },
      { field: 'providerName', headerName: 'Provider Name', width: 210 },
      { field: 'productType', headerName: 'Product Type', width: 180 },
      { field: 'productCreatedDate', headerName: 'Created Date', width: 200, cellRenderer: (data) => {
        return moment(data.value).format('MM/DD/YYYY');        
      } },
      { field: 'carrierService', headerName: 'Carrier Service', width: 210 },
      { field: 'serviceCountry', headerName: 'Service Country', width: 210 }, 
      { field: 'currency', headerName: 'Currency', width: 140 },
      { field: 'faceValueMinAmt', headerName: 'Face value min', width: 200, cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value)}},
      { field: 'faceValueMaxAmt', headerName: 'Face value max', width: 200, cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value)}},
      { field: 'fee', headerName: 'Fee', width: 200, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)}},  
      { field: 'purchaseDiscount', headerName: 'Purchase Discount', width: 230, hide: true },
      { field: 'purchaseDiscountType', headerName: 'Purchase Discount', width: 230,cellRenderer: function (data) {
          
          if (data.value == '$') {
                //return this.currencyPipe.transform(parseFloat(data.data.purchaseDiscount));
                return '$' + parseFloat(data.data.purchaseDiscount);
            }
            if (data.value == '%') {
              return data.data.purchaseDiscount + '%'; //data.purchaseDiscount + '%';
            }
          } 
       },
      { field: 'transactionType', headerName: 'Transaction Type', width: 210 },
      { field: 'responseType', headerName: 'Response Type', width: 210 },
      { field: 'planType', headerName: 'Plan Type', width: 180},
      
    ];
     }
  
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Products.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'productCreatedDate') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter 
      }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }

  exportProductList(){
    this.ProductService.exportAllProducts().subscribe(res => {
        saveAs(res, "TILA-Products.csv") 
        this.toastrService.success(`Product list exported successfully!`)
    })
  }

  // On produc tupload clicked
  onUpload(){
    this.router.navigate(['features/products/products-import'])
  }

}
